const EMPTY_HTML_PATTERNS = ['', '<p></p>', '<p><br></p>', '<p><br/></p>'];

/** Returns true if the string contains HTML markup (not plain text). */
export function isRichTextHtml(content: string): boolean {
  return /<[a-z][\s\S]*>/i.test(content);
}

/** Normalize Tiptap output — treat empty editor states as blank. */
export function normalizeRichTextHtml(html: string | undefined | null): string {
  const trimmed = (html ?? '').trim();
  if (EMPTY_HTML_PATTERNS.includes(trimmed)) {
    return '';
  }
  return trimmed;
}

/** Returns true when rich text or plain text has visible content. */
export function hasRichTextContent(html: string | undefined | null): boolean {
  const normalized = normalizeRichTextHtml(html);
  if (!normalized) {
    return false;
  }
  if (isRichTextHtml(normalized)) {
    const text = normalized.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').trim();
    return text.length > 0;
  }
  return normalized.length > 0;
}
